import Address from "./Address";
import Offer from "./Offer";
import { Container } from "./styled";
import ContentSection from "./ContentSection";
import BikeRental from "../Content/Bikes/BikeRental";
import cruiseImage from "../Content/Cruises/images/full/GRN_0093.webp";
import houseImage from "../Content/Houses/images/full/domek.webp";
import bikeImage from "../Content/Bikes/images/full/bikes.webp";
import GoogleMap from "./GoogleMap";
import CTA from "./CTA";
import cruiseCtaImage from "../Content/Cruises/images/full/cruise.webp";
import housesCtaImage from "../Content/Houses/images/full/DSC7685.webp";
import bikesCtaImage from "../Content/Bikes/images/full/IMG_0172.webp";
import boatsImage from "../Content/Boats/images/full/electric-boats.webp";
import boatsCtaImage from "../Content/Boats/images/full/electric-boats.webp";

const Content = () => {
    return (
        <Container>
            <Offer />
            <ContentSection id="cruises" variant="cruises" imageSrc={cruiseImage} />
            <CTA variant="cruises" imagePosition="right" image={cruiseCtaImage} />
            <ContentSection id="houses" variant="houses" imageSrc={houseImage} />
            <CTA variant="houses" imagePosition="left" image={housesCtaImage} />
            <ContentSection id="bikes" variant="bikes" imageSrc={bikeImage} />
            <CTA variant="bikes" imagePosition="right" image={bikesCtaImage} />
            <BikeRental />
            <ContentSection id="boats" variant="boats" imageSrc={boatsImage} />
            <CTA variant="boats" imagePosition="left" image={boatsCtaImage} />
            <Address />
            <GoogleMap />
        </ Container>
    );
};

export default Content;